import _ from 'lodash';
import {
    SET_INITIAL_STATE,
    SET_CONFIG,
    SET_ACTIVE_COLOR,
    SET_ACTIVE_MATERIAL,
    SET_ACTIVE_PART,
    SET_ACTIVE_MINE,
    SET_ACTIVE_MINE_COLOR,
    SET_ACTIVE_MENU_ITEM,
    SET_ACTIVE_AREA,
    SET_ACTIVE_IMAGE,
    SET_ACTIVE_TEXT,
    SET_IS_TEMPLATE_WARNING_POPUP_VISIBLE,
    DISABLE_TEMPLATE_WARNING_POPUP,
    TOGGLE_SHOULD_TEMPLATE_WARNING_POPUP_BE_DISABLED,
    SET_IS_PRINTABLE_INFO_POPUP_VISIBLE,
    DISABLE_PRINTABLE_INFO_POPUP,
    TOGGLE_SHOULD_PRINTABLE_INFO_POPUP_BE_DISABLED,
    SET_IS_LOADING,
    SET_CUSTOMIZATION_TYPE,
    SET_PEN_SHOTS,
    UNSET_ACTIVES,
    ADD_CUSTOM_COLOR,
    ADD_CUSTOM_IMAGE,
    REMOVE_CUSTOM_IMAGE,
    ADD_CUSTOM_TEXT,
    REMOVE_CUSTOM_TEXT,
    SET_MIN_ORDER_AMOUNT,
    SHOW_NOTIFICATION,
    HIDE_NOTIFICATION,
    SET_PART_MATERIAL_AND_COLOR,
    OPEN_COLOR_PICKER,
    CLOSE_COLOR_PICKER,
    OPEN_TEXT_EDITOR,
    CLOSE_TEXT_EDITOR,
    SET_TEMPLATE,
    SET_MINE_COLOR,
    OPEN_NOTICE_POPUP,
    CLOSE_NOTICE_POPUP,
    SET_NOTICE_POPUP_CONTENT,
} from '../actions/actionCreators/configurator';

const initialState = {
    customColors: [],
    customImages: [],
    customTexts: [],
    penShots: [],
    disabledAreas: [],
    isLoading: true,
    config: {},
    isNotificationVisible: false,
    isTemplateWarningPopupVisible: false,
    isTemplateWarningPopupDisabled: false,
    shouldTemplateWarningPopupBeDisabled: false,
    isPrintableInfoPopupVisible: false,
    isPrintableInfoPopupDisabled: false,
    shouldPrintableInfoPopupBeDisabled: false,
    isNoticePopupVisible: false,
    noticePopupContent: {
        title: '',
        text: '',
        buttonLabel: '',
    },
};

export default function configurator(state = initialState, action) {
    let newState = _.cloneDeep(state);
    switch (action.type) {
        case SET_INITIAL_STATE:
            return Object.assign(state, action.state);
        case SET_CONFIG:
            newState.config = action.config;
            return newState;
        case SET_ACTIVE_PART:
            newState.activePart = action.activePart;
            return newState;
        case SET_ACTIVE_MATERIAL:
            newState.activeMaterial = action.activeMaterial;
            return newState;
        case SET_ACTIVE_COLOR:
            newState.activeColor = action.activeColor;
            return newState;
        case SET_TEMPLATE:
            newState.config.template = action.template;
            return newState;
        case SET_MINE_COLOR:
            newState.config.mine_color = action.mineColor;
            return newState;
        case SET_ACTIVE_MINE:
            newState.activeMine = action.activeMine;
            return newState;
        case SET_ACTIVE_MINE_COLOR:
            newState.activeMineColor = action.activeMineColor;
            return newState;
        case SET_ACTIVE_AREA:
            newState.activeArea = action.activeArea;
            return newState;
        case SET_ACTIVE_IMAGE:
            newState.activeImage = action.activeImage;
            return newState;
        case SET_ACTIVE_TEXT:
            newState.activeText = action.activeText;
            return newState;
        case SET_IS_TEMPLATE_WARNING_POPUP_VISIBLE:
            newState.isTemplateWarningPopupVisible = action.isTemplateWarningPopupVisible;
            return newState;
        case DISABLE_TEMPLATE_WARNING_POPUP:
            newState.isTemplateWarningPopupDisabled = true;
            return newState;
        case TOGGLE_SHOULD_TEMPLATE_WARNING_POPUP_BE_DISABLED:
            newState.shouldTemplateWarningPopupBeDisabled = !newState.shouldTemplateWarningPopupBeDisabled;
            return newState;
        case SET_IS_PRINTABLE_INFO_POPUP_VISIBLE:
            newState.isPrintableInfoPopupVisible = action.isPrintableInfoPopupVisible;
            return newState;
        case DISABLE_PRINTABLE_INFO_POPUP:
            newState.isPrintableInfoPopupVisible = true;
            return newState;
        case TOGGLE_SHOULD_PRINTABLE_INFO_POPUP_BE_DISABLED:
            newState.shouldPrintableInfoPopupBeDisabled = !newState.shouldPrintableInfoPopupBeDisabled;
            return newState;
        case SET_IS_LOADING:
            newState.isLoading = action.isLoading;
            return newState;
        case SET_CUSTOMIZATION_TYPE:
            newState.customizationType = action.customizationType;
            return newState;
        case UNSET_ACTIVES:
            newState.activeColor = null;
            newState.activePart = null;
            newState.activeMaterial = null;
            newState.activeTemplate = null;
            return newState;
        case OPEN_COLOR_PICKER:
            newState.isColorPickerOpen = true;
            return newState;
        case CLOSE_COLOR_PICKER:
            newState.isColorPickerOpen = false;
            return newState;
        case OPEN_TEXT_EDITOR:
            newState.isTextEditorOpen = true;
            return newState;
        case CLOSE_TEXT_EDITOR:
            newState.isTextEditorOpen = false;
            return newState;
        case SET_PEN_SHOTS:
            newState.penShots = action.penShots;
            return newState;
        case ADD_CUSTOM_COLOR:
            newState.customColors.push(action.customColor);
            return newState;
        case ADD_CUSTOM_IMAGE:
            newState.customImages.push(action.customImage);
            return newState;
        case SET_ACTIVE_MENU_ITEM:
            newState.activeMenuItem = action.activeMenuItem;
            return newState;
        case REMOVE_CUSTOM_IMAGE:
            newState.customImages = newState.customImages.filter(image => {
                return image.id !== action.customImage;
            });
            return newState;
        case REMOVE_CUSTOM_TEXT:
            newState.customTexts = newState.customTexts.filter(text => {
                return text.id !== action.customText;
            });
            return newState;
        case ADD_CUSTOM_TEXT:
            newState.customTexts.push(action.customText);
            return newState;
        case SET_MIN_ORDER_AMOUNT:
            newState.config.minOrderAmount = action.minOrderAmount;
            return newState;
        case SHOW_NOTIFICATION:
            newState.isNotificationVisible = true;
            return newState;
        case HIDE_NOTIFICATION:
            newState.isNotificationVisible = false;
            return newState;
        case SET_PART_MATERIAL_AND_COLOR:
            let part = newState.config.parts[action.part];
            part.material = action.material;
            part.color = action.color;
            return newState;
        case OPEN_NOTICE_POPUP:
            newState.isNoticePopupVisible = true;
            return newState;
        case CLOSE_NOTICE_POPUP:
            newState.isNoticePopupVisible = false;
            newState.noticePopupContent = { title: '', text: '', buttonLabel: '' };
            return newState;
        case SET_NOTICE_POPUP_CONTENT:
            newState.noticePopupContent = {
                title: action.title,
                text: action.text,
                buttonLabel: action.buttonLabel,
            };
            return newState;
        default:
            return state;
    }
}
